// Criterio ÚNICO de ocupación de una clase.
//
// 🚨 17-sep-2026: había dos escalas distintas y contradictorias. El calendario
// (ClassesCalendarPage) pintaba ≥90% en ÁMBAR, o sea alerta; el reporte (OccupancyReport)
// pintaba ese mismo ≥90% en VERDE, o sea ideal, y reservaba el ámbar para el sobrecupo.
// Con ese número se decide abrir un segundo grupo o cerrar uno y quitarle horas a un maestro,
// así que no puede significar dos cosas según la pantalla. Gana la escala del reporte:
// llenar la clase es el objetivo; lo que hay que mirar es el sobrecupo y las clases vacías.
export const OCUPACION_ALTA = 90;   // a partir de aquí la clase se considera llena
export const OCUPACION_MEDIA = 50;  // por debajo de aquí, clase floja

export type NivelOcupacion = 'sobrecupo' | 'alta' | 'media' | 'baja' | 'sin_cupo';

/** @param pct ocupación en PORCENTAJE (inscritos / cupo × 100) */
export function nivelOcupacion(pct: number | null): NivelOcupacion {
  if (pct == null || !isFinite(pct)) return 'sin_cupo';
  if (pct > 100) return 'sobrecupo';
  if (pct >= OCUPACION_ALTA) return 'alta';
  if (pct >= OCUPACION_MEDIA) return 'media';
  return 'baja';
}

export const OCUPACION_TEXTO: Record<NivelOcupacion, string> = {
  sobrecupo: 'Sobrecupo', alta: 'Llena', media: 'A media', baja: 'Poco llena', sin_cupo: 'Sin cupo definido',
};
